import { MotorDriverDetailMdl, NCDDetails } from './MotorProposal';
import { MotorPromoReqMdl, MotorPromoResMdl } from './MotorPromoReqMdl';
export class TPLProposal {
    //Policy Details
    public RegNo: string;

    public ProductCode: string;
    public SchemeCode: string;
    public ProposalNo: string;
    public ProposalIssueDate: string;
    public ProposalEffFrom: string;
    public ProposalEffTo: string;

    //Insured Details
    public InsuredIDNo: string;
    public PolSequenceNo: string;
    public InsuredName: string;

    public InsuredNameEn: string;
    public InsuredNameAr: string;


    public InsuredDOB: string;
    public InsuredDOBExits: boolean;

    public InsuredHDOB: string;
    public InsuredHDOBExits: boolean;

    public InsuredPhoneNo: string;
    public InsuredMobileNo: string;
    public InsuredEmailId: string;
    public Gender: string;
    public GenderExits: boolean;

    public InsuredWorkPlace: string;

    public InsuredNationality: string;
    public InsuredNationalityExists: boolean;

    public InsuredNationalityDescEn: string;
    public InsuredNationalityDescAr: string;

    //Resident Address / Establishment Address
    public InsuredBuildingNo: string;
    public InsuredCity: string;
    public InsuredCityExists: boolean;

    public InsuredPostalCode: string;
    public InsuredAdditionalCode: string;
    public InsuredAreaName: string;
    public RegionCode: string;
    public InsuredUnitNo: string;
    public InsuredStreetName: string;
    public InsuredDistName: string;
    public MStatus: string;

    public WaselAddress: string;
    public POBoxAddress: string;

    //waseeladdress
    public InsuredWBuildingNo: string;
    public InsuredWCity: string;
    public InsuredWPostalCode: string;
    public InsuredWAdditionalCode: string;
    public InsuredWAreaName: string;
    public InsuredWStreetName: string;
    public InsuredWDistName: string;
    //POBoxAddress
    public InsuredPOBoxNo: string;
    public InsuredPOPostalCode: string;
    public InsuredPOCity: string;

    public MetAccident: boolean;
    public Under21: boolean;
    public Under21_2: boolean;
    public MetAccidentRemarks: string;

    //Premium Details

    public BasicPremium: string;
    public BasicPremiumChk: boolean;
    public Adminfee: string;
    public AdminfeeChk: boolean;
    public AgeLoading: string;
    public AgeLoadingChk: boolean;
    public AgeLoadingChk2: boolean;
    public DAB: string;
    public PAB: string;
    public DriverCase: string;
    public VehicleCase: string;
    public SI: string;
    public AddDriver: string;
    public AddDriverAmt: string;
    public AddDriverChk: boolean;
    public AddDriverChk2: boolean;

    public AddNPass: string;
    public AddPass: string;
    public AddPassAmt: string;
    public AddPassChk: boolean;
    public TarrifId: string;

    public DPInsuredAccidents: string;
    public DPDriverAccidents: string;
    public DPTotalNoofAccedents: string;
    public DPTotalLiability: string;

    public VCDTotalNoofAccedentsVH: string;
    public VCDTotalLiabilityVH: string;

    public discountAmt: string;
    public discountAmtChk: boolean;
    public discountCode: string;
    public TotalPremium: string;
    public GrossPremium: string;

    public NCDPercent: string;
    public NCDDiscountAmt: string;
    public LossRatio: string;
    public ClaimedAmount: string;
    public ClaimedLibality: string;
    public ExLoadingAmt: string;

    public CountryofOrigin: string;
    public PolFlag: string;
    public PlateTypeCode: string;


    public Drivers: Array<DriverDetails> = new Array<DriverDetails>();
    public DriversLog: Array<DriverDetailsLog> = new Array<DriverDetailsLog>();

    public driverHistoryDetails: Array<DriverHistory> = new Array<DriverHistory>();
    public claimDetails: Array<ClaimsHistory> = new Array<ClaimsHistory>();

    public driverNcdObj: Array<MotorDriverDetailMdl> = new Array<MotorDriverDetailMdl>();
    public driverNCDDetialObj: Array<NCDDetails> = new Array<NCDDetails>();
    public PromoReq: MotorPromoReqMdl = new MotorPromoReqMdl();
    public PromoRes: MotorPromoResMdl = new MotorPromoResMdl();


    public Vechile: VechileDetails = new VechileDetails();

    public seqNo: string;
    public Lng: string;
    public st: StatusInfo;


    //upload docs




    public YakeenFlag: string;
    public YakeenLogid: string;
    public ChkChangeinownership: boolean;
    public OwnerIqama: string;
    public OwnerMakeFlag: string;
    public AccidentLoadingFlag: string;
    public proposalCheck: boolean;
    //Public ProposalAtt As HttpPostedFileBase
    public customeridCheck: boolean;
    // Public customeridAtt As HttpPostedFileBase
    public vregCheck: boolean;
    // Public vregAtt As HttpPostedFileBase
    public dlicCheck: boolean;
    public ncdCheck: boolean;
    // Public dlicAtt As HttpPostedFileBase
    public needDriver: boolean;
    public needDriver2: boolean;
    public upNotes: string;
    public OwnerIqamaNo: string;
    public OwnerIqamaFlag: boolean;
    public IssuenceHijriDate: string;


    public driverMedical: boolean;
    public handicap: boolean;
    public suspended: boolean;
    public offence: boolean;
    public criminal: boolean;
    public haveClaims: boolean;


    public DAnswer: string;


    //NCD

    public NCDNajmFlag: boolean;
    public NajmServiceDown: boolean;
    public PrevInsuranceCompanyCode: string;
    public ClaimFreeYears: string;
    public ApprovedClaimFreeYears: string;
    public RegionFlag: string;

    public isInsured: boolean;
    public dataExists: boolean;

    public vechilekept: boolean;
    public premdeclaration: boolean;
    public isitcommercial: boolean;

    //New
    public InsuredDriverLicenseType: string;
    public InsuredDriverLicIssueDate: string;
    public InsuredDriverLicIssueDateAr: string;


    //For Renewal
    public NajmPolicyNo: string;
    public PolicyNo: string;

    public LDPercentage: string;
    public LDAmount: number;
    public RenewalDiscount: string;

    public RenewalBasic: string;
    public RenewalAgeLoading: string;
    public RenewalNCDAmount: string;
    public RenewalLDAmount: string;
    public RenewalSplDiscount: string;

    public ReniwalUnderwriter: boolean;


    //Promo
    public isPromoApply: string;
    public PromoCode: string;
    public PromoID: string;
    public PromoDiscount: string;
    public PromoPercent: string;


    //SHA
    public vehString: string;
    public prString: string;


    public IBAN: string;
    public BankCode: string;

    public IBAN1: string;
    public IBAN2: string;
    public IBAN3: string;
    public IBAN4: string;
    public IBAN5: string;
    public IBAN6: string;

    public UseOfVehicleCodeExists: boolean;


    //VAT
    public VATPercent: string;
    public VATPercentStr: string;
    public VATAmount: string;
    public VATRegNo: string;
    public TotPremiumBVAT: string;


    public CalculatedRegion: string;

    public CrossSellDiscountPer: number;
    public CrossSellDiscountAmt: number;


    public buildingNumberExists: boolean;
    public additionalNumberExists: boolean;
    public districtExists: boolean;
    public postCodeExists: boolean;
    public streetNameExists: boolean;
    public cityExists: boolean;

    public YakeenSPLogID: string;
    public AllowSaudi: string;

    public InsuredNameExists: boolean;

    public IDRegionCode: string;

    public IDExpiry: string;
    public IDOB: string;

    public IDCity: string;
    public IDCityCode: string;
    public IDRegionName: string;
    public VECCity: string;
    public AddressCity: string;
    public VDType: string;

    public RegionNameEn: string;
    public RegionNameAr: string;
    public UserId: string;
    public InsAge: string;
    public AddressType: string;

    public NoOfClaims: string;

    public InsuredEducation: string;
    public InsuredProfessin: string;
    public Ins_MaritalStatus: string;

    public DriverDiscountAmt: string;
    public DriverDeductionType: string;
    public DriverDiscPer: string;


    public isEditProposal: boolean;
    public EditedProposalNo: number;

    public OfficePostalCode: string;
    public OfficeBuildingNo: string;
    public OfficeAdditionalCode: string;
    public OfficeCity: string;
    public OfficeDistrict: string;
    public OfficeRegionCode: string;
    public OfficeStreet: string;
    public officeAddr: boolean;
    public OfficeZone: string;
    public OfficeUnitNo: number;
   

    public DABSelected: boolean;
    public PABSelected: boolean;
    public colorExists: boolean;
    public VehicleRegExpiryExists: boolean;
    public InsuredDriverLicIssueDateExists: boolean;
    public insuredDriverObj: DriverDetails = new DriverDetails();
    public isDriverRequired: boolean;
    public UPR_VAT_AMOUNT:string;

    public Insured_Education: string;
    public ChildrenUnder: string;

    public DriverMaxLimit: number;

    public NCD_CAL_CODE:number;

    public IsHigherPosition: boolean;
    public HigherPositionCode : number;

}
export class StatusInfo {

    public StatusCode: string;
    public StatusDesc: string;
    public StatusDescAr: string;
    public Remarks: string;

}
export class DriverDetails {
    public isMainDriver: string;

    public DriverNameAr: string;
    public DriverNameEn: string;
    public DriverLicenseNo: string;
    public DriverIDType: string;
    public DriverLicenseType: string;
    public DriverMaritalStatus: string;
    public DriverNationality: string;
    public DriverDOB: string;
    public DriverDOBAr: string;
    public DriverLicIssueDate: string;
    public DriverLicIssueDateAr: string;
    public DriverLicenseTypeCode: string;
    public DriverIDTypeCode: string;
    public DriverNationalityCode: string;
    public DriverMaritalStatusCode: string;
    public LangFlag: string;
    public dCount: boolean;
    public LogId: string;
    public gender: string;
    public DrivingExp: string;
    public isSmoker: string;
    public dependents: string;
    public DriverAge: string;
    public Professioncode: string;
    public DriverMaritalStatusAr: string;
    public DriverMaritalStatusEn: string;
    public isMainDriverEn: string;
    public isMainDriverAr: string;
    public DriverNationalityEn: string;
    public DriverNationalityAr: string;
    public DriverLicenseTypeEn: string;
    public DriverLicenseTypeAr: string;

    public isInsured: boolean;
    public DriverAddress: string;
    public DriverCity: string;
    public DriverCityEn: string;
    public DriverCityAr: string;
    public DriverEducation: string;
    public DriverEducationEn: string;
    public DriverEducationAr: string;
    public DriverProfession: string;
    public DriverProfessionEn: string;
    public DriverProfessionAr: string;
    public DriverChildrenYears: string;
    public SaudiLicenceHeld: string;
    public OtherCountriesLicenceHeld: string;
    public OtherCountriesLicenceHeldEn: string;
    public OtherCountriesLicenceHeldAr: string;
    public DriverMedicalConditions: string;
    public NumberOfYearsEachCountry: string;
    public Drivergender: string;
    public Driver_Age: string;
    public RelationWithInsured: string;
    public DriverLic_ExpiryDate: string; 


    public ResidenceAdditionalNumber: number;
    public ResidenceBuildingNumber: number;
    public ResidenceCity: number;
    public ResidenceDistrict: string;
    public ResidenceStreet: string;
    public ResidenceUnitNumber: number;
    public ResidenceZipCode: number;
    public ResidenceZone: string;

    public OfficeUnitNumber: number;
    public OfficeZone: string;
    public OfficeZipCode: number;
    public OfficeAdditionalNumber: number;
    public OfficeBuildingNumber: number;
    public OfficeDistrict: string;
    public OfficeStreet: string;
    public OfficeCity: number;

    public RoadConvictions: number;

    
  
}
export class DriverDetailsLog {
    public IqamaId: string;
    public LogId: string;
}
export class DriverHistory {
    public DriverName: string;
    public NatureOfoffence: string;
    public FinedAmount: string;
    public offenceDate: string;
}
export class ClaimsHistory {
    public InsurerName: string;
    public NatureofClaim: string;
    public AmountofClaim: string;
    public DateofClaim: string;

}

export class VechileDetails {
    public VehicleDefType: string;
    public VehicleUsageCode: string;
    public VehiclePlateTypeCode: string;
    public VehiclePlateNo: string;
    public VehicleFLetter: string;
    public VehicleSLetter: string;
    public VehicleTLetter: string;
    public VehicleModelCode: string;
    public VehicleMakeCode: string;
    public VehicleMakeCodeFlag: boolean;
    public VehicleMakeCodeFlag2: boolean;
    public VechileModelEn: string;
    public VechileModelAr: string;
    public VechileMakeEn: string;
    public VechileMakeAr: string;
    public VehicleCoverageType: string;
    public VehicleCoverDiscCode: string;
    public VehicleFullPlateNoEn: string;

    public VehicleFullPlateNoAr: string;
    public VehicleSequenceNo: string;
    public VehicleCustomId: string;
    public VehicleChassisNo: string;
    public VehicleTypeCode: string;
    public VehicleManfYear: string;
    public VehicleColor: string;
    public VehicleLicenseExpDate: string;
    public VehicleLicenseExpDateEn: string;
    public VehicleCoverBasic: string;
    public VehicleCoverAddAge: string;
    public VehicleCoverDiscAmount: string;
    public VehicleNoofPsng: string;
    public VehicleCoverAddPsngCount: string;
    public VehicleCoverAdminFee: string;
    public VehicleCoverAddDriver: string;
    public VehicleNetAmount: string;
    public RiskIssueDateEn: string;
    public RiskEffFromEn: string;
    public RiskEffToEn: string;
    public LangFlag: string;
    public VechileColorId: string;
    public VechileWeight: string;
    public VechileWeightExists: boolean;
    public VechileAge: number;

    public StreetDesc: string;
    public mileage: string;
    public HorsePower: string;
    public InsuredCity: string;
    public Vequipped: string;
    public Restraints: string;
    public BodyType: string;
    public BodyTypeDesc: string;
    public RCity: string;
    public RCityCode: string;
    public RRegion: string;
    public RRegionCode: string;
    public PlateColour: string;
    public RegExpirydate: string;

    public AddOnAccessoriesCode: string;
    public AdditionalAccessories: string;
    public Marketvalue: string;
    public UseOfVehcileEn: string;
    public PlateTypeEn: string;
    public PlateTypeAr: string;

    public VechTypeEn: string;
    public VechTypeAr: string;

    public Transmission: string;
    public EngineSize: string;
    public RearCamera: string;
    public FrontCamera: string;
    public FrontSensor: string;
    public RearParkingSensor: string;
    public AdaptiveControl: string;
    public CrusieControl: string;
    public AutoBrakingSystem: string;
    public AntiLockBrakingSystem: string;
    public DegreeCamera: string;
    public FireExtingushier: string;
    public ModificationsInCar: string;
    public AxieWeight: string;
    public MileagePerYear: string;
    public ModificationsInCarDesc: string;
    public VehicleParkingNight: string;
    public Vehicle_RegExpirydateHijri: string;
    public  Vehicle_Mileage:string;

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/TPLProposal.ts